

export default function AllInButton({ onClick, text, disabled = false, className = '', id, tabIndex }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !disabled) {
      onClick(e);
    }
  };

  const handleClick = (e) => {
    // Only handle mouse clicks, not focus events
    if (e.detail > 0 && !disabled) {
      onClick(e);
    }
  };

  return (
    <button 
      id={id}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      tabIndex={tabIndex}
      className={`px-2 rounded border-1 text-theme-headerBg border-theme-headerBg hover:bg-theme-headerBg hover:text-theme-color rounded-1 text-sm focus:bg-theme-sidebarBg focus:text-theme-color outline-none   py-[2px] font-medium ${className} `}
    >
      {text}
    </button>
  );
};

